import { useEffect, useState } from "react";

import { Controller, useForm } from "react-hook-form";

import CustomButton from "components/common/CustomButton";
import { toast } from "sonner";
import { useLocation, useNavigate } from "react-router-dom";
import Axios from "services/api/config";
import { setPasswordURL } from "services/api/routes/Auth";
import CustomPasswordInput from "components/formComponents/CustomPassword";

interface FormData {
	password: string;
	confirmPassword: string;
}

const SetPasswordForm = () => {
	const navigate = useNavigate();
	const location: any = useLocation();
	const requestId = location.state?.id;
	const [state, setState] = useState({
		loading: false,
	});
	const {
		control,
		handleSubmit,
		formState: { errors },
	} = useForm<FormData>();

	useEffect(() => {
		if (!requestId) {
			toast.error("Invalid Request!");
			navigate("/");
		}
	}, [navigate, requestId]);

	const onSubmit = async (data: FormData) => {
		try {
			setState((prev) => ({ ...prev, loading: true }));
			console.log(data);
			if (!data.password || !data.confirmPassword)
				return toast.error("Please Enter Password!");
			if (data.password !== data.confirmPassword)
				return toast.error("Password must be same!");
			const { data: res }: any = await Axios({
				...setPasswordURL,
				data: { newPassword: data.password, requestId },
			});
			toast.success(res.message);
			navigate(`/login`);
		} catch (error) {
			console.error(error);
		} finally {
			setState((prev) => ({ ...prev, loading: false }));
		}
	};

	return (
		<div className="md:w-1/2 w-full flex justify-center items-center md:px-8 md:max-h-screen overflow-auto">
			<div className="p-8 flex flex-col justify-center items-center gap-4 text-black text-center w-full">
				<div className="text-2xl md:text-4xl uppercase font-bold font-carmine">
					Set New Password!
				</div>
				{/* <Typography className="text-lg mb-2 text-center text-wrap">
					Welcome Back! Please log in to access your dashboard and manage your
					store.
				</Typography> */}

				<form onSubmit={handleSubmit(onSubmit)} className="w-full">
					<div className="flex flex-col gap-4 w-full">
						{/* Password */}
						<Controller
							name="password"
							control={control}
							defaultValue=""
							// rules={{
							//   required: "Password is required.",
							// }}
							render={({ field }) => (
								<CustomPasswordInput
									{...field}
									className="border-2 border-gray-400 rounded-md"
									placeholder="Password"
									error={errors.password?.message}
								/>
							)}
						/>
						{/* Password */}
						<Controller
							name="confirmPassword"
							control={control}
							defaultValue=""
							// rules={{
							//   required: "Password is required.",
							// }}
							render={({ field }) => (
								<CustomPasswordInput
									{...field}
									className="border-2 border-gray-400 rounded-md"
									placeholder="Password"
									error={errors.confirmPassword?.message}
								/>
							)}
						/>
						{/* Create Account Button */}
						<CustomButton
							title="Submit"
							type="submit"
							className="w-full"
							isLoading={state.loading}
							// isLoading={true}
						/>
					</div>
				</form>

				{/* Login Link */}
				{/* <p className="text-sm mt-2 text-center text-black">
					New User?{" "}
					<Link to="/register" className="text-primary font-semibold">
						Create Account
					</Link>
				</p> */}
			</div>
		</div>
	);
};

export default SetPasswordForm;
